export default {"src":"/_next/static/image/public/images/flags/flag_963.9d94bf6cee3e730d8f5a739cb45e51ae.svg","height":16,"width":24};